import {
  fetchAddNewbuildingToFavorites,
  fetchRemoveNewbuildingFromFavorites,
  INewbuildingInfo,
} from '../../api/newbuildings';
import { IAppState, TActions, Dispatch } from '../../common/state';

export interface ISetNewbuildingFavoriteAction {
  type: 'serp/newbuilding_info/SET_NEWBUILDING_FAVORITE';
  isFavorite: boolean;
}

function setNewbuildingFavoriteAction(isFavorite: boolean): ISetNewbuildingFavoriteAction {
  return {
    type: 'serp/newbuilding_info/SET_NEWBUILDING_FAVORITE',
    isFavorite,
  };
}

export function newbuildingInfoReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'serp/newbuilding_info/SET_NEWBUILDING_FAVORITE':
      const newbuildingInfo: INewbuildingInfo | null = state.results.newbuildingInfo && {
        ...state.results.newbuildingInfo,
        isFavorite: action.isFavorite,
      };

      return {
        ...state,
        results: {
          ...state.results,
          newbuildingInfo,
        },
      };
    default:
      return state;
  }
}

export function setNewbuildingFavorite(isFavorite: boolean, newbuildingId: number) {
  return (dispatch: Dispatch, getState: () => IAppState) => {
    const { makeRequest, user } = getState();

    const { waitForLoginPopup, __header_favorites_count__ = 0, __header_updateFavorites__ } = window as any; // tslint:disable-line:no-any

    const toggle = (state: boolean) => {
      dispatch(setNewbuildingFavoriteAction(state));
      if (__header_updateFavorites__) {
        __header_updateFavorites__(state);
      }
    };

    if (isFavorite && !user.isAuthenticated && __header_favorites_count__ >= 5 && waitForLoginPopup) {
      waitForLoginPopup('favorites');
    } else {
      toggle(isFavorite);

      if (isFavorite) {
        fetchAddNewbuildingToFavorites(makeRequest, newbuildingId).catch(() => toggle(false));
      } else {
        fetchRemoveNewbuildingFromFavorites(makeRequest, newbuildingId).catch(() => toggle(true));
      }
    }
  };
}
